import debounce from 'lodash.debounce';

const modules = document.querySelectorAll( '.module--medium:not(.module--alignCenter), .module--large:not(.module--alignCenter)' );

function setModuleheight() {
	if ( window.innerWidth < 768 ) {
		for ( let i = 0; i < modules.length; i += 1 ) {
			modules[i].removeAttribute( 'style' );
		}

		return;
	}

	for ( let i = 0; i < modules.length; i += 1 ) {
		const padding = modules[i].classList.contains( '.module--alignBottom' ) ? 180 : 70;
		const box = modules[i].querySelector( '.module-box' );
		modules[i].setAttribute( 'style', `min-height:${box.offsetHeight + padding}px` );
	}
}

function initEvents() {
	window.addEventListener( 'resize', debounce( setModuleheight, 250 ) );
}

function init() {
	if ( !modules ) {
		return;
	}
	setModuleheight();
	initEvents();
}

export default {
	init,
};
